import { Fragment, ReactNode } from 'react'
import classnames from 'classnames'

export default function MediaNewsNavItem({
  children,
  isActive,
  onClick,
}: {
  children: ReactNode
  isActive: boolean
  onClick: () => void
}): React.ReactElement {
  const cx = classnames(
    'px-1.5',
    'py-1',
    'relative',
    'rounded',
    'text-xs',
    'font-medium',
    isActive ? 'text-purple' : 'hover:bg-purple-light',
  )

  return (
    <button className={cx} onClick={onClick}>
      <span>{children}</span>

      {isActive && (
        <Fragment>
          <span className="absolute top-full left-0 w-full h-0.5 bg-purple" />
        </Fragment>
      )}
    </button>
  )
}
